import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Intrested.css";

const Interested = () => {
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  // Professional enterprise-level categories
  const interests = [
    { 
      id: "All", 
      name: "All Categories", 
      description: "Access all learning domains",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect width="7" height="9" x="3" y="3" rx="1"/>
          <rect width="7" height="5" x="14" y="3" rx="1"/>
          <rect width="7" height="9" x="14" y="12" rx="1"/>
          <rect width="7" height="5" x="3" y="16" rx="1"/>
        </svg>
      ),
      color: "#6366f1"
    },
    { 
      id: "K12", 
      name: "K12", 
      description: "School-level education and curriculum",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 3l9 4.5-9 4.5-9-4.5 9-4.5z"/>
          <path d="M3 7.5v9l9 4.5 9-4.5v-9"/>
          <path d="M12 12v9"/>
        </svg>
      ),
      color: "#14b8a6"
    },
    { 
      id: "Industry", 
      name: "Industry", 
      description: "Manufacturing and automation",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M2 20h20"/>
          <path d="M7 16v4"/>
          <path d="M12 12v8"/>
          <path d="M17 8v12"/>
          <path d="M22 4L12 14l-3-3-5 5"/>
        </svg>
      ),
      color: "#0ea5e9"
    },
    { 
      id: "Technology", 
      name: "Technology", 
      description: "Digital innovation and IT solutions",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      color: "#06b6d4"
    },
    { 
      id: "Agriculture", 
      name: "Agriculture", 
      description: "Sustainable farming methods",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2a3 3 0 0 0-3 3c0 1.5 1 2.75 2.5 2.75S14 6.5 14 5a3 3 0 0 0-3-3Z"/>
          <path d="M12 16c1.5 0 3.5-.5 3.5-2.75S13.5 10.5 12 10.5"/>
          <path d="M12 16c-1.5 0-3.5-.5-3.5-2.75S10.5 10.5 12 10.5"/>
          <path d="M12 22v-6"/>
        </svg>
      ),
      color: "#10b981"
    },
    { 
      id: "Mathematics", 
      name: "Mathematics", 
      description: "Data science and modeling",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
      color: "#f59e0b"
    },
    { 
      id: "Vocational", 
      name: "Vocational", 
      description: "Professional skill development",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect width="20" height="14" x="2" y="7" rx="2" ry="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
      ),
      color: "#ec4899"
    },
    { 
      id: "UPSC", 
      name: "UPSC", 
      description: "Civil services and competitive exam preparation",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M8 12h8M12 8v8"/>
        </svg>
      ),
      color: "#8b5cf6"
    },
    { 
      id: "Medical", 
      name: "Medical", 
      description: "Medical education and healthcare training",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2v20M2 12h20"/>
          <circle cx="12" cy="12" r="10"/>
        </svg>
      ),
      color: "#ef4444"
    },
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleSelect = (interestId) => {
    if (interestId === "All") {
      setSelectedInterests(["All"]);
    } else {
      if (selectedInterests.includes("All")) {
        setSelectedInterests([interestId]);
      } else {
        if (selectedInterests.includes(interestId)) {
          setSelectedInterests(selectedInterests.filter((i) => i !== interestId));
        } else {
          setSelectedInterests([...selectedInterests, interestId]);
        }
      }
    }
  };

  const handleContinue = () => {
    if (selectedInterests.length > 0) {
      localStorage.setItem("selectedInterests", JSON.stringify(selectedInterests));
      navigate("/allpages");
    }
  };

  const handleClose = () => {
    navigate("/allpages");
  };

  return (
    <div className={`modal-backdrop ${isVisible ? 'visible' : ''}`}>
      <div className="modal-container">
        {/* Header */}
        <div className="modal-header1">
          <div className="header-content">
            <div className="brand-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
            </div>
            <div className="header-text">
              <h1 className="modal-title">Select Learning Areas</h1>
              <p className="modal-subtitle">Choose your areas of interest to personalize your learning experience</p>
            </div>
          </div>
          <button className="close-button" onClick={handleClose} aria-label="Close dialog">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="modal-content">
          <div className="interests-container">
            {interests.map((interest) => (
              <div
                key={interest.id}
                className={`interest-option ${selectedInterests.includes(interest.id) ? 'selected' : ''}`}
                onClick={() => handleSelect(interest.id)}
                role="checkbox"
                aria-checked={selectedInterests.includes(interest.id)}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSelect(interest.id);
                  }
                }}
              >
                <div className="option-content">
                  <div className="option-icon" style={{ backgroundColor: `${interest.color}15`, color: interest.color }}>
                    {interest.icon}
                  </div>
                  <div className="option-text">
                    <h3 className="option-title">{interest.name}</h3>
                    <p className="option-description">{interest.description}</p>
                  </div>
                  <div className="option-checkbox">
                    <div className="checkbox" style={{ backgroundColor: selectedInterests.includes(interest.id) ? interest.color : 'transparent', borderColor: selectedInterests.includes(interest.id) ? interest.color : '#d1d5db' }}>
                      {selectedInterests.includes(interest.id) && (
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                          <polyline points="20,6 9,17 4,12"/>
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="footer-info">
            {selectedInterests.length > 0 ? (
              <span className="selection-count">
                {selectedInterests.length} {selectedInterests.length === 1 ? 'area' : 'areas'} selected
              </span>
            ) : (
              <span className="selection-hint">Please select at least one area to continue</span>
            )}
          </div>
          <div className="footer-actions">
            <button
              className={`primary-button ${selectedInterests.length === 0 ? 'disabled' : ''}`}
              onClick={handleContinue}
              disabled={selectedInterests.length === 0}
            >
              Continue to Dashboard
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14m-7-7 7 7-7 7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interested;